/**
 * @file getQuestion.ts
 * Exports a method that fetches a question object for a given questionId.
 */
import { pipe, find, propEq } from 'ramda';
import { getQuestions } from '.';
import type { AppState, QuestionData } from '../types';

/**
 * Helper method that returns a question object for a given questionId.
 *
 * @param {AppState} appState
 *   The state object shared across the application.
 * @param {string} id
 *   The id of a question in the source questions data.
 *
 * @returns {QuestionData|undefined}
 *   Question data object, or undefined.
 */
export default (appState: AppState, id: string): QuestionData =>
  pipe(
    // Retrieve the list of question from appState.
    getQuestions,
    // Find and return the question object with matching question id.
    find(propEq('id', id)),
  )(appState);
